import classNames from "classnames";
import { useRef, useState } from "react";
import styles from "./style.module.scss";
import Spinner from "../spinner";

const RIPPLE_DURATION_MS = 600;

interface BtnProps extends React.HTMLProps<HTMLButtonElement> {
  containerStyle: any;
  Icon: any;
  iconStyle: any;
  IconDirection: string;
  disabled?: boolean;
  loading?: boolean;
  titleStyle?: any;
}

const CustomButton = ({
  title,
  onClick,
  containerStyle,
  Icon,
  iconStyle,
  IconDirection,
  disabled,
  style,
  loading,
  titleStyle,
  type = "submit",
}: Partial<BtnProps> & { type?: "button" | "submit" | "reset" }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [ripple, setRipple] = useState<{ x: number; y: number } | null>(null);

  const direction = {
    left: "left",
    right: "right",
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled || loading) return;
    const btn = buttonRef.current;
    if (btn) {
      const rect = btn.getBoundingClientRect();
      setRipple({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      });
      setTimeout(() => setRipple(null), RIPPLE_DURATION_MS);
    }
    onClick?.(e);
  };

  return (
    <button
      ref={buttonRef}
      className={classNames(
        containerStyle && containerStyle,
        styles.customBtnContainer,
      )}
      onClick={handleClick}
      disabled={disabled || loading}
      type={type}
      style={style}
    >
      {ripple && (
        <span
          className={styles.rippleClip}
          aria-hidden
        >
          <span
            className={styles.ripple}
            style={{ left: ripple.x, top: ripple.y }}
          />
        </span>
      )}
      {loading ? (
        <Spinner />
      ) : (
        <>
          {IconDirection === direction.left ? (
            Icon ? (
              <Icon className={iconStyle ? iconStyle : ""} />
            ) : null
          ) : null}
          <span className={classNames(titleStyle)}>{title}</span>
          {IconDirection === direction.right ? (
            Icon ? (
              <Icon className={iconStyle ? iconStyle : ""} />
            ) : null
          ) : null}
        </>
      )}
    </button>
  );
};

export default CustomButton;
